import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import { capitalizeFirstLetter } from "../../helpers";
import moment from "moment";
import { ModalHeader } from "../Styles/InputStyles";
import ModalProfileHeader from "../Common/ModalProfileHeader";

const ViewPropsModel = ({
    handleClose,
    selectedData,
}) => {
    const [height, setHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Lease Summary</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            {/* <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {capitalizeFirstLetter(selectedData?.name || '')}
                    </span>
                    <span className="text-sm text-gray-600">#{selectedData?.mobile}</span>
                </UserInfo>
                <Summary>
                    <SummaryItem>
                        <span className="text-xs text-gray-500">Lease</span>
                        <span className="text-lg font-semibold">
                            {selectedData?.properties?.length || 0}
                        </span>
                    </SummaryItem>
                </Summary>
            </ProfileSection> */}

            <ModalProfileHeader
                title="Lease Summary"
                name={capitalizeFirstLetter(selectedData?.name)}
                subtitle={`#${selectedData?.mobile}`}
                amountLabel={"No Of Lease"}
                amount={selectedData?.properties?.length || 0}
                image={selectedData?.profilePicture}
                onClose={handleClose}
                showCurrency={false}
            />
            {/* Property List */}
            <Content>
                {selectedData?.properties?.length > 0 ? (
                    selectedData.properties.map((property, index) => (
                        <PropertyCard key={property.id || index}>
                            <CardHeader>
                                <div>
                                    <p className="font-medium text-gray-800 truncate max-w-[250px]">{capitalizeFirstLetter (property?.propName || 'N/A')}</p>
                                    <p className="font-normal text-sm text-gray-500 truncate max-w-[250px]">{property.propAddress}</p>
                                </div>
                                <StatusBadge status={property?.agreementStatus}>
                                    {property?.agreementStatus || "N/A"}
                                </StatusBadge>
                            </CardHeader>

                            <Divider />

                            <Grid>
                                <FlexCol>
                                    <Label>Rent</Label>
                                    <Value>₹{property.leaseRent || 0}</Value>
                                </FlexCol>

                                <FlexCol>
                                    <Label>Security</Label>
                                    <Value>₹{property.leaseSecurity || 0}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Agreement</Label>
                                    <Value>
                                        {property.startDate
                                            ?
                                            (property.startDate
                                                ? moment(property.startDate).format("DD, MMM YY")
                                                : "-")
                                            + ' - ' +
                                            (property.endDate
                                                ? moment(property.endDate).format("DD, MMM YY")
                                                : "-")
                                            : "Not Available"}
                                    </Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Dues</Label>
                                    <Value className="text-red-600 font-medium">
                                        ₹{property.pendingDues || 0}
                                    </Value>
                                </FlexCol>
                                {property.flatName &&
                                    <FlexCol>
                                        <Label>Flat Name</Label>
                                        <Value>{property.flatName || 'N/A'}</Value>
                                    </FlexCol>
                                }
                            </Grid>
                        </PropertyCard>
                    ))
                ) : (
                    <EmptyState>No properties found</EmptyState>
                )}
            </Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative `;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const Card = tw.div`
    bg-white border border-gray-200 rounded-lg p-3 
`;

const Grid = tw.div`grid grid-cols-2 gap-4`;

const PropertyCard = tw.div`
  bg-white border border-gray-200 rounded-lg p-4
`;

const Summary = tw.div`flex gap-6`;

const SummaryItem = tw.div`
  flex flex-col text-right
  .label { @apply text-xs text-gray-500; }
  .value { @apply text-lg font-semibold; }
`;
const CardHeader = tw.div`
  flex justify-between items-start
`;

const StatusBadge = tw.span`
  text-xs px-2 py-1 rounded-full
  ${({ status }) =>
        status === "Active"
            ? "bg-green-100 text-green-700"
            : status === "Expiring"
                ? "bg-amber-100 text-amber-700"
                : "bg-gray-100 text-gray-600"}
`;

const Divider = tw.div`h-px bg-gray-200 my-3`;
const Content = tw.div`px-4 py-4 space-y-4 overflow-y-auto`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-sm md:text-base`;

const FlexCol = tw.div`flex flex-col gap-0.5`;

const EmptyState = tw.div`
  text-center text-gray-500 text-sm py-10
`;
export default ViewPropsModel;